export default __webpack_public_path__ + "static/media/about-img.8cb1d60d.jpg";